<template>
  <div :class="isDefaultLabel ? '' : 'search-field'">
    <input
      :class="isDefaultLabel ? '' : 'search-field__input'"
      :placeholder="placeholder"
      v-model="search"
      ref="searchField"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :disabled="disabled"
    />
    <icon
      v-if="!isDefaultLabel"
      name="find"
      class="search-field__icon-find"
      :class="{ 'search-field__icon-find_highlight': search?.length }"
    />
    <button
      class="search-field__icon-delete"
      v-if="search?.length && !isDefaultLabel"
      @click="clearSearch"
    >
      <icon name="delete" />
    </button>

    <div
      v-if="autocomplete && autocompleteList?.length"
      class="search-field__autocomplete"
    >
      <simplebar>
        <div
          v-for="item of autocompleteList"
          :key="`${item.id}`"
          class="item-autocomplete"
          @click="$emit('autocompleteClick', item)"
          v-html="item.name"
        ></div>
      </simplebar>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchField",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    autocompleteList: {
      type: Array,
      default: () => []
    },
    isDefaultLabel: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clearSearch() {
      this.search = "";
      this.$refs.searchField.focus();
    }
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-field {
  width: 440px;
  height: 40px;

  position: relative;

  &__input {
    width: 100%;
    height: 100%;

    padding: 0 26px;

    box-sizing: border-box;

    font-size: 13px;

    &::placeholder {
      color: #cdced0;
    }

    outline: none;

    border: none;
    border-bottom: 1px solid transparent;

    &:focus {
      border-bottom-color: #cdced0;
    }

    /* clears the 'X' from Internet Explorer */
    &::-ms-clear {
      display: none;
      width: 0;
      height: 0;
    }
    &::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }

    /* clears the 'X' from Chrome */
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }

    &[disabled] {
      background-color: #fff;
      pointer-events: none;
      user-select: none;
    }
  }

  &__icon-find,
  &__icon-delete {
    width: 16px;
    height: 16px;

    color: #a3a8b3;

    position: absolute;
    top: 11px;
  }

  &__icon-find {
    left: 0;

    pointer-events: none;
    user-select: none;

    &_highlight {
      color: #005197;
    }
  }

  &__icon-delete {
    right: 0;

    cursor: pointer;

    background: none;
    border: none;
    outline: none;
    padding: 0;

    .svg-icon {
      width: 16px;
      height: 16px;

      color: inherit;
    }
  }

  &__autocomplete {
    position: absolute;
    z-index: 13;
    top: calc(100% + 10px);
    left: 0;
    overflow: hidden;
    width: 100%;
    border-radius: 2px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;

    .ps {
      max-height: 200px;
    }
  }
}
</style>

<style lang="scss">
@import "@v2/app/styles/mixins";

.search-field {
  &__autocomplete {
    .item-autocomplete {
      @include button-clean();
      box-sizing: border-box;

      display: block;
      width: 100%;
      padding: 10px 16px;

      font-size: 13px;
      line-height: 1.54;
      color: #000;
      text-align: left;

      &:hover {
        background: #009ee3;
        color: #fff;
      }
    }
  }
}
</style>
